/** Offering / Seeking — maps to API `request_type`. */
export const REQUEST_TYPE_OPTIONS = [{
    value: '1',
    viewValue: 'Seeking'
}, {
    value: '2',
    viewValue: 'Offering'
}];
